module.exports = __webpack_public_path__ + "img/distribuidor.93142011.png";